import React from "react";
import Select, { type SingleValue } from "react-select";
import { useScheduleTeam } from "../../../../hooks/scheduleTeam";
import type { AgendaConsultant } from "../../agendaTypes";
import MobileTeamSelect from "./MobileTeamSelect";
import { mobileSelectStyles, type MobileSelectOption } from "./mobileSelectStyles";

type Props = {
  viewerId: number;
  consultants: AgendaConsultant[];
  selectedConsultantId: number;
  onSelectConsultant: (consultantId: number | undefined) => void;
};

/** Consultant mobile view: switch team and look at a teammate's agenda. */
const MobileTeamAgendaControls: React.FC<Props> = ({
  viewerId,
  consultants,
  selectedConsultantId,
  onSelectConsultant,
}) => {
  const { myTeams, usesTeamSchedules } = useScheduleTeam();
  const showTeam = usesTeamSchedules && myTeams.length > 1;
  const showConsultant = consultants.length > 1;

  if (!showTeam && !showConsultant) {
    return null;
  }

  const options: MobileSelectOption[] = consultants.map((consultant) => ({
    value: consultant.id,
    label: consultant.id === viewerId ? `${consultant.first_name} (você)` : consultant.first_name,
  }));

  return (
    <section
      className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2"
      aria-label="Agenda do time"
    >
      <MobileTeamSelect />
      {showConsultant ? (
        <div className="min-w-0">
          <span className="sr-only">Agenda de</span>
          <Select<MobileSelectOption>
            aria-label="Ver agenda de"
            options={options}
            value={options.find((option) => option.value === selectedConsultantId) ?? options[0]}
            onChange={(option: SingleValue<MobileSelectOption>) => {
              const id = option ? Number(option.value) : undefined;
              // Own agenda is the default, so it does not need to stay in the filters.
              onSelectConsultant(id === viewerId ? undefined : id);
            }}
            isSearchable={false}
            styles={mobileSelectStyles}
            menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
            menuPosition="fixed"
          />
        </div>
      ) : null}
    </section>
  );
};

export default MobileTeamAgendaControls;
